<template>
    <div class="search-input">
        <ion-input
            v-model="address"
            autofocus="true"
            fill="outline"
            shape="round"
            v-on:keyup.enter="search"
            placeholder="Search by city &amp; state or zip"
            :disabled="processingSearch"
            data-cy="input-search"
            class="font-18"
            style="color: black"
            mode="md"
        />
        <ion-button @click="search" :disabled="processingSearch" clear item-right fill="clear" class="ion-no-padding custom-button" data-cy="button-search">
            <ion-spinner v-if="processingSearch" name="lines-small" />
            <ion-icon v-else :ios="searchSharp" :md="searchSharp" color="medium" slot="end" />
        </ion-button>

        <ion-item fill="outline" v-if="false" mode="md" class="search-item"> </ion-item>
    </div>
</template>

<script lang="ts">
import { IonButton, IonIcon, IonInput, IonItem, IonSpinner } from '@ionic/vue';
import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { searchSharp } from 'ionicons/icons';
import SearchAddressWithUserCoordsModel from '@/models/searchAddressWithUserCoordsModel';

export default defineComponent({
    components: { IonItem, IonInput, IonButton, IonIcon, IonSpinner },
    setup() {
        const address = ref('');
        const store = useStore();
        const userCoords = computed(() => store.getters.userCoordinates);

        const search = () =>
            store.dispatch(
                'setNearLocationsByAddress',
                new SearchAddressWithUserCoordsModel({
                    address: address.value,
                    userCoordinates: userCoords.value,
                })
            );

        const processingSearch = computed(() => store.getters.processingNearLocations);
        return { address, search, processingSearch, searchSharp };
    },
});
</script>

<style scoped>
.search-item {
    padding-top: 16px !important;
}
.search-input {
    position: relative;
    margin-top: 18px;
}
.custom-button {
    position: absolute;
    top: 6px;
    right: 18px;
    z-index: 1212 !important;
}
@media screen and (max-width: 960px) {
    .search-item {
        padding-top: 2px !important;
    }
    .custom-button {
        position: absolute;
        top: 8px;
        right: 45px;
    }
}
</style>
